import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss']
})
export class SplashComponent implements OnInit {
  windowWidth: string;
  showSplash = true;
  constructor(private router: Router) { }



  ngOnInit(): void {
    setTimeout(() => {
      this.windowWidth = "-" + window.innerWidth + "px";
      this.router.navigate(['/']);

      setTimeout(() => {
        this.showSplash = !this.showSplash;
      }, 500);
    }, 2000);
    }

}
